export enum TypeMessageEnum {
  SUCESSO = 'tipo-mensagem/SUCESSO',
  IMPEDITIVO = 'tipo-mensagem/IMPEDITIVO',
  NAO_IMPEDITIVO = 'tipo-mensagem/NAO_IMPEDITIVO',
  INFORMATIVO = 'tipo-mensagem/INFORMATIVO'
}
